"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@/shared/ui/buttons/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/shared/ui/modals/dialog";
import { RespondMessageField } from "./respond-message-field";

export interface RespondTarget {
  postId: string;
  role: string;
  /** Кому отклик: название команды. */
  toName: string;
}

interface RespondDialogProps {
  target: RespondTarget | null;
  pending: boolean;
  onCancel: () => void;
  onSend: (target: RespondTarget, message: string) => void;
}

function RespondBody({ target, pending, onCancel, onSend }: RespondDialogProps & { target: RespondTarget }) {
  const t = useTranslations("LfgBoard");
  const [message, setMessage] = useState("");
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSend(target, message);
      }}
      className="space-y-4"
    >
      <RespondMessageField value={message} onChange={setMessage} />
      <DialogFooter className="items-center sm:justify-between">
        <span className="truncate text-xs text-muted-foreground">{t("respond.to", { name: target.toName })}</span>
        <div className="flex gap-2">
          <Button type="button" variant="ghost" onClick={onCancel}>{t("card.cancel")}</Button>
          <Button type="submit" disabled={pending} className="bg-highlight font-bold text-primary-foreground hover:bg-highlight/90">
            {t("respond.send")}
          </Button>
        </div>
      </DialogFooter>
    </form>
  );
}

/** «Отклик на объявление» (макет): подпись необязательна, отправляется вместе с откликом. */
export function RespondDialog(p: RespondDialogProps) {
  const t = useTranslations("LfgBoard");
  return (
    <Dialog open={p.target !== null} onOpenChange={(open) => !open && p.onCancel()}>
      <DialogContent className="sm:max-w-[440px]">
        <DialogHeader>
          <DialogTitle className="font-heading text-[22px]">{t("respond.title")}</DialogTitle>
          <DialogDescription className="sr-only">{t("respond.signature")}</DialogDescription>
        </DialogHeader>
        {p.target && <RespondBody {...p} target={p.target} />}
      </DialogContent>
    </Dialog>
  );
}
